"use client";

import { cn } from "@/lib/utils";

export function KbdBadge({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <kbd
      className={cn(
        "pointer-events-none inline-flex h-[16px] min-w-[16px] select-none items-center justify-center rounded border border-line-2 bg-panel-2 px-[4px] font-mono text-[9px] font-medium leading-none text-fg-mute",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
